import { jsxs as r, jsx as l } from "react/jsx-runtime";
const o = (h) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M53.69 35.702a13.22 13.22 0 0 1 3.428 3.049c.58-2.175.882-4.44.882-6.751a25.81 25.81 0 0 0-4.022-13.898l-4.086 1.095A21.84 21.84 0 0 1 54 32c0 1.254-.105 2.49-.31 3.702ZM35.75 33h-7.5v2h7.5v-2Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M41.298 19.969H22.415l-3.184 7.644H15.78l.536 2h2.907V42.97h6.39v-3.834H36.25c.538-.733 1.15-1.409 1.825-2.015H21.222v-7.507h21.556v4.789c.646-.21 1.314-.373 2-.481v-4.308h2.872l.535-2h-3.417l-3.47-7.644Zm-12.767 7.644h-7.133l2.35-5.644h7.279l-2.496 5.644Zm4.373 0L35.4 21.97h4.61l2.561 5.644h-9.667Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M35.637 53.701c-1.19.197-2.406.299-3.637.299a21.856 21.856 0 0 1-15.556-6.444A21.856 21.856 0 0 1 10 32a21.856 21.856 0 0 1 6.444-15.556 21.841 21.841 0 0 1 14.631-6.424c.642 2.607 2.908 4.539 5.597 4.539h6.678v-1.837h3.914v-3H43.35V7.307h3.914v-3H43.35V2.471h-6.678c-2.33 0-4.343 1.452-5.255 3.536-6.727.147-13.029 2.835-17.802 7.608C8.705 18.526 6 25.055 6 32c0 6.945 2.704 13.474 7.615 18.385C18.526 55.295 25.055 58 32 58c2.285 0 4.524-.295 6.677-.862a13.216 13.216 0 0 1-3.04-3.437Zm1.035-48.23h3.678v6.088h-3.678c-1.532 0-2.778-1.366-2.778-3.044 0-1.679 1.246-3.044 2.778-3.044Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M46.83 35.76c-6.138 0-11.114 4.976-11.114 11.114 0 6.138 4.976 11.114 11.114 11.114 6.138 0 11.114-4.976 11.114-11.114 0-6.138-4.975-11.114-11.114-11.114Zm0 19.231c-4.476 0-8.117-3.641-8.117-8.117 0-4.476 3.641-8.117 8.117-8.117 4.476 0 8.117 3.641 8.117 8.117 0 4.476-3.641 8.117-8.117 8.117Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m40.88 38.874-2.122 2.12L52.78 55.017l2.121-2.122-14.02-14.02Z"
        }
      )
    ]
  }
);
export {
  o as UnavailableCharger
};
